// Browser chrome colour (theme-color) follows the app theme, also when it overrides the system scheme: where Chrome still paints a solid bar
// (3-button navigation, the "chin" before edge-to-edge applies), it then matches the UI instead of the system colour.
export const THEME_COLORS = {light: '#ffffff', dark: '#171e28'}; // = --bg of the two themes (style.css)
export function installThemeColor(doc = document, win = globalThis) {
  const apply = () => {
    const color = THEME_COLORS[doc.documentElement.dataset.theme] ?? THEME_COLORS.light;
    for (const meta of doc.querySelectorAll('meta[name="theme-color"]')) meta.setAttribute('content', color);
  };
  apply();
  const observer = new win.MutationObserver(apply);
  observer.observe(doc.documentElement, {attributes: true, attributeFilter: ['data-theme']});
  return {apply, observer};
}
